const CloseIcon = (): React.ReactElement => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.97549 2.16737C2.75233 1.94421 2.39052 1.94421 2.16737 2.16737C1.94421 2.39052 1.94421 2.75233 2.16737 2.97549L5.19188 6L2.16737 9.02451C1.94421 9.24767 1.94421 9.60948 2.16737 9.83263C2.39052 10.0558 2.75233 10.0558 2.97549 9.83263L6 6.80812L9.02451 9.83263C9.24767 10.0558 9.60948 10.0558 9.83263 9.83263C10.0558 9.60948 10.0558 9.24767 9.83263 9.02451L6.80812 6L9.83263 2.97549C10.0558 2.75233 10.0558 2.39052 9.83263 2.16737C9.60948 1.94421 9.24767 1.94421 9.02451 2.16737L6 5.19188L2.97549 2.16737Z"
        fill="#47535C"
      />
    </svg>
  );
};

export default CloseIcon;
